import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for consistent error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message || error.message || 'Something went wrong';
    return Promise.reject(new Error(message));
  }
);

// ==================== IMAGE URL HELPER ====================
// Backend stores images as relative paths like "/uploads/filename.jpg"
// This helper converts them to absolute URLs
export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};

// ==================== ENQUIRY APIS ====================
// @desc    Submit a new enquiry from public form
// @route   POST /api/enquiry
// @access  Public
export const submitEnquiry = (data) => api.post('/enquiry', data);

// ==================== BLOG APIS ====================
// @desc    Get all published blogs with pagination & category filter
// @route   GET /api/blogs?category=&page=&limit=
// @access  Public
export const getPublicBlogs = (params) => api.get('/blogs', { params });

// @desc    Get a single blog by its slug
// @route   GET /api/blogs/:slug
// @access  Public
export const getBlogBySlug = (slug) => api.get(`/blogs/${slug}`);

// ==================== COLLEGE APIS ====================
// @desc    Get all colleges with optional country & top college filter
// @route   GET /api/colleges?country=&isTopCollege=
// @access  Public
export const getPublicColleges = (params) => api.get('/colleges', { params });

// @desc    Get top colleges only
// @route   GET /api/colleges?isTopCollege=true
// @access  Public
export const getTopColleges = () => api.get('/colleges', { params: { isTopCollege: 'true' } });

// ==================== FEE STRUCTURE APIS ====================
// @desc    Get Indian colleges fee structure (optional state filter)
// @route   GET /api/fees?state=
// @access  Public
export const getFeeStructure = (params) => api.get('/fees', { params });

// @desc    Get distinct states with fee data
// @route   GET /api/fees/states
// @access  Public
export const getFeeStates = () => api.get('/fees/states');

// ==================== TESTIMONIAL APIS ====================
// @desc    Get all testimonials
// @route   GET /api/testimonials
// @access  Public
export const getTestimonials = () => api.get('/testimonials');

export default api;